import type { TColors } from '../models';

type TTheme = 'white' | 'blue';

export const colorsMap: Record<string, TColors> = {
    white: 'default',
    blue: 'inverted',
};

/**
 * @deprecated Хелпер мигрирует пропс theme (@alfa-bank/site-button) на colors (@alfa-bank/site-button-v2)
 */
export const getButtonColorsByTheme = (
    buttonTheme?: TTheme | TColors | string
): TColors | undefined => {
    if (!buttonTheme) return;

    return colorsMap[buttonTheme] ?? (buttonTheme as TColors);
};
